import React from 'react'
import RasterLayer from './RasterLayer'

const IceDriftDirection = () => {
  return (
    <RasterLayer
      id='IceDriftDirection'
      authId='IceDrift'
      />
  )
}

export default IceDriftDirection



// WEBPACK FOOTER //
// ./src/layers/IceDriftDirection.js